import React, { useContext, useEffect, useState } from "react";
import HeaderTop from "./common/Header/HeaderTop";
import Sidebar from "./common/Sidebar";
import HeaderMain from "./common/Header/HeaderMain";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Home from "./pages/Home";
import ExchangeInplay from "./pages/ExchangeInplay";
import Footer from "./common/Footer";
import Casino from "./pages/Casino";
import LoginPopup from "./components/LoginPopup";
import { GlobalContext } from "./global/GlobalProvider";
import rip from "./assets/ripple_svg3.svg";
import face from "./assets/error-crying-face.svg";
import AccountStatemnt from "./pages/report/AccountStatemnt";
import Slots from "./pages/Slots";
import ProtectedRouts from "./pages/ProtectedRouts";
import InPlay from "./pages/InPlay";
import MyBets from "./pages/report/MyBets";
import ActivityLog from "./pages/report/ActivityLog";
import LiveCasinoResult from "./pages/report/LiveCasinoResult";
import SportbookResult from "./pages/report/SportbookResult";
import Sportbook from "./pages/Sportbook";
import Lottry from "./pages/Lottry";
import FantacyGame from "./pages/FantacyGame";
import LiveCasinoInPlay from "./pages/LiveCasinoInPlay";
import NewHome from "./pages/NewHome";
import BannerPopup from "./components/BannerPopup";
import Iframe from "./Iframe";
import config from "./config";
import SecureAuth from "./pages/report/SecureAuth";
import OTPVerifyPopup from "./components/OTPVerifyPopup";

export default function ChildApp() {

  const {closeSuccessPopup, closeErrorPopup,alerMsg, isSuccessRes, isErrorRes,isLoading, setLoading,loggedIn,setCurrentTheme, currentTheme } = useContext(GlobalContext);
  const location = useLocation();
  const [isMaintanace, setisMaintanace] = useState(false);
  const [isCalled, setIsCalled] = useState(false);
  let flag = false;

  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    if (currentTheme) {
      document.documentElement.setAttribute("data-theme", currentTheme);
    }
    // document.documentElement.setAttribute("data-theme", theme);
  }, [currentTheme]);

  useEffect(() => {
    let timer;
    if (isSuccessRes) {
      timer = setTimeout(() => {
        closeSuccessPopup();
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [isSuccessRes]);

  useEffect(() => {
    callGameReport();
      const intervalId = setInterval(callGameReport, 5000);
      return () => {clearInterval(intervalId);}},[]);

      const callGameReport = () => {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);
    
          const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
          };
          fetch(`${process.env.REACT_APP_BASE_URL}/maintanace?whiteLabel=${window.location.hostname}`, requestOptions)
            .then(async (response) => {
              let paresData = await response.json();
              setisMaintanace(paresData.maintananceStatus);
              if (paresData.maintananceStatus) {
                if (!isCalled) {
                  Navigate("/");
                }
                setIsCalled(true);
              }
            })
            .catch((error) => {
              // console.log("logInCheck - ",error);
            });
      };

  useEffect(() => {
    let timer;
    if (isErrorRes) {
      timer = setTimeout(() => {
        closeErrorPopup();
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [isErrorRes]);

  const checkFlag = () =>{
    return location.pathname==='/accountstatement' || 
          location.pathname==='/currentbets' || 
          location.pathname==='/report/activity' || 
          location.pathname==='/livecasinoresult' || 
          location.pathname==='/sportbookresult' || 
          location.pathname==='/casino' || 
          location.pathname==='/slots' || 
          location.pathname==='/fantasygames' || 
          location.pathname==='/secureauth' || 
          checkLiveCAsinoPlay()
  }

  const checkLiveCAsinoPlay = () =>{
    return location.pathname.includes('/live_casinoInPlay/')
  }

  const navigate = useNavigate();

  useEffect(() => {
    console.log("location.pathname", location.pathname);
    
    if (location.pathname === "/") {
      const auth = sessionStorage.getItem('loggedIn') || loggedIn ;
      if (auth) {
        navigate('/sport');
      } else {
        if (!config.isWhiteLabel) {
          console.log("not white label");
          navigate('/sport');
        }else{
          console.log("white label");
          navigate('/');
        }
      }
    }else if (location.pathname === '/sport') {
      const auth = sessionStorage.getItem('loggedIn') || loggedIn ;
      if (auth) {
        navigate('/sport');
      } else {
        if (!config.isWhiteLabel) {
          console.log("not white label");

          navigate('/sport');
        }else{
          console.log("white label");

          navigate('/');
        }
      }
    }
  }, []);

     useEffect(() => {
        // if (location.pathname === '/') {document.title = "World777";}
        // else if (location.pathname === '/sport') { document.title = "Exchange"; }
        // else if (location.pathname === '/slots') { document.title = "Slots"; }
        // else if (location.pathname === '/lottry') { document.title = "Lottry"; }
        // else if (location.pathname === '/fantasygames') { document.title = "Fantacy Game"; }
        // else if (location.pathname.includes('/live_casinoInPlay')) { document.title = "Live Casino"; }
        // else if (location.pathname === '/accountstatement') { document.title = "Account Statement"; }
        // else if (location.pathname === '/report/activity') { document.title = "Activity Log"; }
        // else if (location.pathname === '/livecasinoresult') { document.title = "Live Casino Result"; }
        // else if (location.pathname === '/sportbookresult') { document.title = "Sportbook Result"; }
        // else if (location.pathname === '/sportbook') { document.title = "Sportbook"; }
        // else if (location.pathname === '/currentbets') { document.title = "My Bets"; }
        // else if (location.pathname.includes('/exchange_inPlay/')) { document.title = "Exchange"; }
        
      }, [location]);

      const checkLogin = () => {
        if(sessionStorage.getItem('loggedIn') || loggedIn || flag ){
          return true;
        }else{
          if (!config.isWhiteLabel) {
            return true;
          }else{
            return false;
          }
        }
      }

      useEffect(() => {
        config.isWhiteLabel ? document.body.classList.add("homeV1") : document.body.classList.add("homeV2");
      }, []);
     

  return (
    <>
    {isMaintanace ? <> 
          <div className="match-not-found">
                      <h2>
                        <div style={{marginBottom:'10px',color:'#aaafb5'}}>
                          <img src={face} alt="loder" height={'150px'} width={"150px"}/>
                        </div>
                        <span>Our server is currently undergoing maintenance. Services may be temporarily unavailable. We apologize for the inconvenience and appreciate your patience.</span>
                      </h2>
                      <p>Opps! Please try again later</p>
                      <div className="error-404-btn">
                              <button className="btn" onClick={()=>window.location.reload()}>home</button>
                      </div>
                  </div>
        </> :<>
      {checkLogin()  ? <HeaderTop />:''}
      <div className={`main-content ${checkFlag() ? 'no-sidemenu':''} ${sessionStorage.getItem('loggedIn') || loggedIn ? 'loggedIn' : ''}`}>
        {checkLogin() ? <Sidebar /> :''}
        <div className="page-content">
          {checkLogin() ? <HeaderMain /> :''}
          <Routes>
          {checkLogin() ? <Route path="/exchange_inPlay/:eventId/:mId" element={<InPlay />} />:''}
          {checkLogin() ? <Route path="/exchange_inPlay/:eventId" element={<InPlay />} />:''}
          {checkLogin() ? <Route path="/casino" element={<Casino />} /> :''}
          {checkLogin() ? <Route path="/slots" element={<Slots />} /> :''}
          {checkLogin() ? <Route path="/sportbook" element={<Sportbook />} />:''}
          {checkLogin() ? <Route path="/lottry" element={<Lottry />} />:''}
          {checkLogin() ? <Route path="/fantasygames" element={<FantacyGame />} />:''}

          {config.isWhiteLabel ? <Route path="/" element={<NewHome />} /> :<Route path="/sport" element={<Home />} />}
            <Route element={<ProtectedRouts/>}>
              <Route path="/sport" element={<Home />} />
              {checkLogin() ? '' :<Route path="/exchange_inPlay/:eventId/:mId" element={<InPlay />} />}
              {checkLogin() ? '' :<Route path="/exchange_inPlay/:eventId" element={<InPlay />} />}
              
              {checkLogin() ? '' :<Route path="/casino" element={<Casino />} />}
              {checkLogin() ? '' :<Route path="/slots" element={<Slots />} />}
              {checkLogin() ? '':<Route path="/lottry" element={<Lottry />} />}
              {checkLogin() ? '':<Route path="/fantasygames" element={<FantacyGame />} />}
              <Route path="/live_casinoInPlay/:gameId" element={<LiveCasinoInPlay />} />
              <Route path="/accountstatement" element={<AccountStatemnt />} />
              <Route path="/secureauth" element={<SecureAuth />} />
              <Route path="/report/activity" element={<ActivityLog />} />
              <Route path="/livecasinoresult" element={<LiveCasinoResult />} />
              <Route path="/sportbookresult" element={<SportbookResult />} />
              {checkLogin() ? '':<Route path="/sportbook" element={<Sportbook />} />}
              <Route path="/currentbets" element={<MyBets />} />
            </Route>
          </Routes>
          {checkLiveCAsinoPlay() ? '' :<Footer />}
          <LoginPopup />
          <OTPVerifyPopup />
          <BannerPopup />
          <div className={`alert ${isSuccessRes ? 'open' : ''}`}><i className="fas fa-check-circle"></i> {alerMsg} </div>
          <div className={`alert error ${isErrorRes ? 'open' : ''}`}><i className="fa fa-times-circle" aria-hidden="true"></i> {alerMsg} </div>
          <div className={`loader ${isLoading? 'show':''}`}><img src={rip} alt="loder" height={'200px'} width={"200px"}/></div>
        </div>
      </div>
      </>
    }
    </>
  );
}